'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _draftJs = require('draft-js');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _utils = require('../../utils');

var _link = require('../../../../icon/link.svg');

var _link2 = _interopRequireDefault(_link);

var _styles = require('./styles.css');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// eslint-disable-line no-unused-vars


var Image = (_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Image, _Component);

    function Image() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, Image);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Image.__proto__ || (0, _getPrototypeOf2.default)(Image)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isSelected: false,
            hovered: false
        }, _this.focusBlock = function () {
            var _this$props = _this.props,
                block = _this$props.block,
                blockProps = _this$props.blockProps;
            var getEditorState = blockProps.getEditorState,
                setEditorState = blockProps.setEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var newSelection = new _draftJs.SelectionState({
                anchorKey: key,
                focusKey: key,
                anchorOffset: 0,
                focusOffset: 1
            });
            setEditorState(_draftJs.EditorState.forceSelection(editorState, newSelection));
        }, _this.toggleEnter = function () {
            _this.setState({
                hovered: true
            });
        }, _this.toggleLeave = function () {
            _this.setState({
                hovered: false
            });
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Image, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            var block = props.block,
                blockProps = props.blockProps;
            var getEditorState = blockProps.getEditorState;

            var key = block.getKey();
            var editorState = getEditorState();
            var currentblock = (0, _utils.getCurrentBlock)(editorState);
            this.setState({
                isSelected: currentblock.getKey() === key
            });
        }
        // 组件获取焦点

    }, {
        key: 'renderLinkOption',
        value: function renderLinkOption(customData) {
            var _this2 = this;

            return _react2.default.createElement(
                'div',
                { className: 'rde-custom-toolbar' },
                _react2.default.createElement(
                    'button',
                    { className: 'rde-block-button', title: '\u67E5\u770B\u539F\u6587', onClick: function onClick() {
                            return _this2.props.blockProps.customBlockConfig.goLink(customData);
                        } },
                    _react2.default.createElement('img', { src: _link2.default, alt: 'Left' })
                )
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                block = _props.block,
                contentState = _props.contentState;

            var entityKey = block.getEntityAt(0);
            var blockData = {
                customData: undefined
            };
            if (entityKey) {
                var entity = contentState.getEntity(entityKey);
                blockData = entity.getData();
            }
            var _blockData = blockData,
                customData = _blockData.customData;

            return _react2.default.createElement(
                'div',
                {
                    className: 'rde-custom-block',
                    onClick: this.focusBlock,
                    onMouseEnter: this.toggleEnter,
                    onMouseLeave: this.toggleLeave,
                    role: 'presentation'
                },
                _react2.default.createElement(
                    'div',
                    { className: (0, _classnames2.default)('rde-custom-wrapper', { 'rde-custom-is-selected': this.state.isSelected })
                    },
                    this.props.blockProps.customBlockConfig.renderCustomBlock(customData),
                    this.state.hovered && this.renderLinkOption(customData)
                )
            );
        }
    }]);
    return Image;
}(_react.Component), _class.propTypes = {
    block: _propTypes2.default.object,
    contentState: _propTypes2.default.object,
    blockProps: _propTypes2.default.object
}, _temp2);
exports.default = Image;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/src/blocks/Custom/index.js
// module id = 132
// module chunks = 0